import type { Repeat } from '../company-tasks/types';

/** "Moje zadania" (zadania prywatne): the server's shapes and the query key. Only the author ever gets them. */
export const PRIVATE_KEY = ['private-tasks'] as const;
export const PRIVATE_BASE = '/api/me/private-tasks';

export type PrivateTask = {
  id: string;
  title: string;
  notes: string;
  dueDay: string | null;
  dueTime: string | null;
  repeat: Repeat | null;
  eventId: string | null;
  /** null: no link, or the author may no longer see the event. */
  eventName: string | null;
  contractorId: string | null;
  contractorName: string | null;
  done: boolean;
  doneAt: string | null;
  version: number;
};

export type View = 'today' | 'week' | 'later' | 'nodate' | 'all' | 'done';
export const VIEWS: { id: View; label: string }[] = [
  { id: 'today', label: 'Dziś' },
  { id: 'week', label: 'Ten tydzień' },
  { id: 'later', label: 'Później' },
  { id: 'nodate', label: 'Bez daty' },
  { id: 'all', label: 'Wszystkie' },
  { id: 'done', label: 'Zrobione' },
];
export const isView = (v: string | null): v is View => VIEWS.some((x) => x.id === v);
export type ListAnswer = { tasks: PrivateTask[]; counts: Record<Exclude<View, 'done'>, number>; today: string };

export const EMPTY_TEXT: Record<View, string> = {
  today: 'Nic na dziś. Dodaj zadanie w linii powyżej.',
  week: 'Nic do końca tygodnia.',
  later: 'Nic zaplanowanego na później.',
  nodate: 'Nie ma zadań bez daty.',
  all: 'Nie masz zadań do zrobienia.',
  done: 'Nie ma jeszcze zrobionych zadań.',
};

/** The link shown in a row and in the dialog: the event's or kontrahent's name (only what the author still sees). */
export const linkText = (t: Pick<PrivateTask, 'eventName' | 'contractorName'>): string => [t.eventName, t.contractorName].filter(Boolean).join(' · ');
